import {observer} from 'mobx-react-lite';
import React from 'react';
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import {FONT_COLOR, FONT_VARIANT} from "../../../../components/fonts/font-props";
import Hr from "../../../../components/hr/hr";
import Card from "../../../../components/layouts/card/card";
import './rma-fees-card.scss';
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import {IValidationGroup} from "../../../../hooks/validation-group/validation-group-hook";
import RmaRequestStore from '../../stores/rma-request-store';
import RmaLabelFee from "./rma-label-fee";
import RmaReturnFee from "./rma-return-fee";



interface IRMAFeesCardProps {
    rmaRequestStore: RmaRequestStore;
    validationGroup: IValidationGroup;
	isPolicyLedMode?: boolean;
}

const RMAFeesCard: React.FC<IRMAFeesCardProps> = observer(({rmaRequestStore, validationGroup, isPolicyLedMode = false}) => {

    const returnFeeStore = rmaRequestStore.rmaFeesListStore.returnFee;
	const labelFeeStore = rmaRequestStore.rmaFeesListStore.labelFee;
    
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-create-rma';
    
	return (
		<div className={'rma-fees-card'}>
			<Card isExpandable={true} toolbar={{title:<FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('RMA_FEES', scope)}</FontBody1>}}>
				<RmaReturnFee store={returnFeeStore} rmaRequestStore={rmaRequestStore} validationGroup={validationGroup}  isPolicyLedMode={isPolicyLedMode}/>
				<Hr/>
				<RmaLabelFee store={labelFeeStore} rmaRequestStore={rmaRequestStore} validationGroup={validationGroup} isPolicyLedMode={isPolicyLedMode}/>
			</Card>
		</div>
	)
});

export default RMAFeesCard;